/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdataroom_Name3Inputs */

const en_coinvestments_lpdataroom_name3 = /** @type {(inputs: Coinvestments_Lpdataroom_Name3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Coinvestments_Lpdataroom_Name3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdataroom_name3 = /** @type {((inputs?: Coinvestments_Lpdataroom_Name3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdataroom_Name3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdataroom_name3(inputs)
});
export { coinvestments_lpdataroom_name3 as "coInvestments_lpDataRoom_name" }